export const IMAGE_TOOLS = [
  {
    id: "fall-bingo",
    title: "Fall Bingo",
    description: "Celebrate autumn adventures and earn your Fall Adventure Champion badge.",
    icon: "🍁",
    path: "./fall-bingo",
    comingSoon: false,
  },
  {
    id: "plushie-avatar",
    title: "Plushie Avatar Generator",
    description: "Upload a photo and create your plushie version in seconds.",
    icon: "🧸",
    path: "./plushie-avatar",
    comingSoon: false,
  },
  {
    id: "photo-booth",
    title: "Photo Booth",
    description: "Create a four-panel race collage with your photo and custom zoom.",
    icon: "📸",
    path: "./photo-booth",
    comingSoon: false,
  },
  {
    id: "memory-game",
    title: "Flip the Feed",
    description: "Match pairs made from the community's most-loved photos of the week.",
    icon: "🧩",
    path: "./memory-game",
    comingSoon: false,
  },
  {
    id: "moon-challenge",
    title: "Moon Challenge",
    description: "Visit The Big Canada Run Moon Challenge.",
    icon: "🌙",
    path: "https://race.mychallengecanada.ca/tbcr-moon-challenge",
    external: true,
    comingSoon: false,
  },
  {
    id: "style-presets",
    title: "More Coming Soon",
    description: "We are adding more image generation styles and tools soon.",
    icon: "✨",
    path: "",
    comingSoon: true,
  },
];
